webpackJsonp([144251824217401],{

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(51);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContainerModule = __webpack_require__(57);
	
	var _ContainerModule2 = _interopRequireDefault(_ContainerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_React$Component) {
		_inherits(Container, _React$Component);
	
		function Container() {
			_classCallCheck(this, Container);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Container.prototype.render = function render() {
			var _cx;
	
			var children = this.props.children;
	
			var classes = (0, _classnames2.default)(_ContainerModule2.default.container, (_cx = {}, _cx[_ContainerModule2.default.text] = this.props.text, _cx));
			return _react2.default.createElement(
				'div',
				{ className: classes },
				children
			);
		};
	
		return Container;
	}(_react2.default.Component);
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Container----Container-module---container---3KHiT"};

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReveal = __webpack_require__(65);
	
	var _HeaderModule = __webpack_require__(111);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
		_inherits(Header, _React$Component);
	
		function Header() {
			_classCallCheck(this, Header);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Header.prototype.render = function render() {
			var children = this.props.children;
	
			return _react2.default.createElement(
				'div',
				{ className: _HeaderModule2.default.header },
				_react2.default.createElement(
					_reactReveal.Fade,
					{ down: true, tag: 'h1' },
					children
				)
			);
		};
	
		return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Header----Header-module---header---2gV_n"};

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(92);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(49);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(69);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Hero = __webpack_require__(70);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
		_inherits(About, _React$Component);
	
		function About() {
			_classCallCheck(this, About);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		About.prototype.render = function render() {
			// const jivo = require('../../jivo')
			return _react2.default.createElement(
				'div',
				{ className: 'container about-container' },
				_react2.default.createElement(_reactHelmet2.default, { title: 'About | ' + _SiteConfig2.default.siteTitle }),
				_react2.default.createElement(_Hero2.default, { title: 'About', subtitle: 'Andreas Teneketzoglou' }),
				_react2.default.createElement(
					_Container2.default,
					{ text: true },
					_react2.default.createElement(
						'p',
						null,
						'Multi-disciplined electrical and computer engineer, purpose-oriented and conscientious self-starter, able to strategize and prioritize effectively to accomplish multiple tasks and stay calm under pressure. Flexible and analytical with a keen eye for details; skilled at synthesizing and editing information to achieve overall objectives. Creative, resourceful and flexible, able to adapt to changing priorities and maintain a positive attitude and strong work ethic.'
					)
				),
				_react2.default.createElement(_Footer2.default, null)
			);
		};
	
		return About;
	}(_react2.default.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-511cfcc6c325bddd1c97.js